import React from 'react';
import { motion } from 'framer-motion';

type Props = {
  id: string;
  selectedId?: string;
};

export const PaymentItem: React.FC<Props> = ({ id, selectedId, children }) => {
  const defaultStyle = { scale: 1, opacity: 1 };
  let animateTo = defaultStyle;
  if (selectedId) {
    animateTo = id === selectedId ? { scale: 1.1, opacity: 1 } : { scale: 1, opacity: 0.5 };
  }

  return (
    <motion.div
      className='col-auto mb-2'
      initial={defaultStyle}
      animate={animateTo}
      style={{
        pointerEvents: selectedId ? 'none' : 'auto',
        zIndex: selectedId === id ? 1 : 'auto',
      }}
    >
      {children}
    </motion.div>
  );
};
